import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './app';
import { GlobalStyle } from './_layouts/layout.styles';

const root = ReactDOM.createRoot(
  document.getElementById('root')
);
root.render(
  <React.StrictMode>
    <GlobalStyle />
    <App />
  </React.StrictMode>
);
